module.exports = __webpack_public_path__ + "71c9cffb49b81bedf5330af0a096409f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/reading-levels/onlevel.png
// module id = 3603
// module chunks = 0